import React from 'react';
export function Gallery() {
  const images = [{
    url: 'https://images.unsplash.com/photo-1545105511-91e0cdb76c8d?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    alt: 'Green pastures'
  }, {
    url: 'https://images.unsplash.com/photo-1596733430284-f7437764b1a9?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    alt: 'Dairy cow close up'
  }, {
    url: 'https://images.unsplash.com/photo-1605000797499-95a51c5269ae?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    alt: 'Farm equipment'
  }, {
    url: 'https://images.unsplash.com/photo-1500937386664-56d1dfef3854?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    alt: 'Wheat field'
  }, {
    url: 'https://images.unsplash.com/photo-1516253593875-bd7ba052fbc5?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    alt: 'Tractor in field'
  }, {
    url: 'https://images.unsplash.com/photo-1594771804886-7153100d296c?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    alt: 'Calves'
  }];
  return <section id="gallery" className="py-20 bg-white" data-id="element-230">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-231">
        <div className="text-center mb-16" data-id="element-232">
          <h2 className="text-3xl md:text-4xl font-bold text-green-900 mb-4" data-id="element-233">
            Farm Gallery
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto" data-id="element-234">
            Glimpses of life at GreenSlopes Farm. From our lush fields to our
            happy herd.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-235">
          {images.map((image, index) => <div key={index} className="group relative overflow-hidden rounded-xl shadow-md aspect-[4/3] cursor-pointer" data-id="element-236">
              <img src={image.url} alt={image.alt} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" data-id="element-237" />
              <div className="absolute inset-0 bg-black/0 group-hover:bg-black/30 transition-colors duration-300 flex items-center justify-center" data-id="element-238">
                <p className="text-white opacity-0 group-hover:opacity-100 font-medium transform translate-y-4 group-hover:translate-y-0 transition-all duration-300" data-id="element-239">
                  {image.alt}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}